module.exports = __webpack_public_path__ + "img/video4.802ed4a4.jpg";